import ApiClient from './ApiClient';

class AutomationFormsAPI extends ApiClient {
  constructor() {
    super('automation_forms', { accountScoped: true });
  }
}

export default new AutomationFormsAPI();
